import * as actions from './actions'
import { default as randomBytes } from './randomBytes'

const DEFAULT_TIMEOUT = 3000
const DEFAULT_PROPS = {}

// TODO: Replace this with crypto.randomUUID()
// crypto.randomUUID() requires a secure context (HTTPS or localhost), which
// isn't true for cucumber specs, once we swap off cucumber, we can use crypto.randomUUID instead

function generateRandomUUID() {
  const bytes = randomBytes(16);

  // Per RFC 4122 §4.4:
  // Set version to 4 => xxxx -> 0100
  bytes[6] = (bytes[6] & 0x0f) | 0x40;

  // Set variant to RFC 4122 => 10xxxxxx
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = bytes.toString('hex');

  return (
    hex.slice(0, 8) +
    '-' +
    hex.slice(8, 12) +
    '-' +
    hex.slice(12, 16) +
    '-' +
    hex.slice(16, 20) +
    '-' +
    hex.slice(20)
  );
}

function middleware(options = {}) {
  const {
    getState,
    timeout: globalTimeout = DEFAULT_TIMEOUT,
    props: globalProps = DEFAULT_PROPS,
  } = options
  if (getState) throw new Error('redux-flash: Middleware must be initialized as a function.')
  // Handle actions
  return () => next => action => {
    // Only handle actions of special type
    if (action.type !== actions.FLASH_MESSAGE_ACTION_TYPE) return next(action)
    const {
      payload: {
        message,
        options: {
          push = false,
          isError = false,
          timeout = globalTimeout,
          props = {},
        }
      }
    } = action
    const id = generateRandomUUID()
    // Dispatch appropriate internal actions
    if (push) next(actions.clearMessages())
    next(actions._addMessage({ id, message, isError, props: { ...globalProps, ...props } }))
    if (timeout) setTimeout(() => next(actions.removeMessage(id)), timeout)
  }
}

export default middleware